module.exports = __webpack_public_path__ + "img/custom_client_seed_2_pt.f7799ebc.png";